import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function OverthinkingTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['overthinking-testi']} />;
}
